import React from 'react';
import { useAuth, AuthRole } from '../contexts/AuthContext';
import { LoginForm } from './LoginForm';

export const ProtectedRoute: React.FC<{ children: React.ReactNode; requiredRole: AuthRole }> = ({ children, requiredRole }) => {
  const { isAuthenticated, role } = useAuth();
  return isAuthenticated && role === requiredRole ? <>{children}</> : <LoginForm role={requiredRole} />;
};
